import { render } from "./CxOverlayControls.vue?vue&type=template&id=22ef9b16"
import script from "./CxOverlayControls.vue?vue&type=script&lang=js"
export * from "./CxOverlayControls.vue?vue&type=script&lang=js"

import "./CxOverlayControls.vue?vue&type=style&index=0&id=22ef9b16&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__